#import "~/graphql/fragments/contentBuilder/contentBlocks.graphql"
#import "~/graphql/fragments/seo/index.graphql"

fragment grantArchiveSection on grantArchive_Entry {
    __typename
    id
    slug
    title
    contentBlocks {
        ... contentBlocks
    }
    seo {
        ... socialFragment
    }
}
